import type { ReactElement } from "react";

import type { IFilterViewBaseModelProps } from "app/pages/sales-intelligence/modules/advanced-search-filtering/types/filterInstance";
import { LimitedChipItems } from "app/pages/sales-intelligence/common-components/filters-panel";
import { MAX_CHIPS_GROUP_AMOUNT } from "app/pages/sales-intelligence/common-components/filters-panel/constants";
import type { AppsAndroidCategoryDescriptionDto } from "app/pages/sales-intelligence/modules/find-apps-filters/types/description.dto";
import type { IAppsAndroidCategoryFilter } from "app/pages/sales-intelligence/store/find-apps/types";

import { StyledAppCategoryFilterResult } from "./styles";

const AppAndroidCategoryFilterResult = ({
    value,
    onFilterUpdate,
    isExpanded,
}: IFilterViewBaseModelProps<IAppsAndroidCategoryFilter, AppsAndroidCategoryDescriptionDto>): ReactElement | null => {
    const categoryValues = (value as IAppsAndroidCategoryFilter)?.values || [];

    const chipItems = categoryValues.map((item: string) => ({ id: item, text: item }));
    const handleRemoveValue = (valueItem: string) => {
        const filterData = { values: categoryValues.filter((item: string) => item !== valueItem) };
        onFilterUpdate(filterData.values.length > 0 ? filterData : undefined);
    };

    if (categoryValues.length === 0) {
        return null;
    }

    return (
        <StyledAppCategoryFilterResult>
            <LimitedChipItems
                items={chipItems}
                onDelete={handleRemoveValue}
                maxItems={MAX_CHIPS_GROUP_AMOUNT}
                isTabExpanded={isExpanded}
            />
        </StyledAppCategoryFilterResult>
    );
};

export default AppAndroidCategoryFilterResult;
